import React, { useContext, useEffect, useState } from 'react';
import Smallchatbox from '../components/Chatbox/Smallchatbox';
import { Context as UserContext } from '../context/UserContext';
import {
  sendChatMessage,
  retrieveMoreMessages,
  deleteChatMessage,
} from '../api/expoHallSocket';
import ExhibitorContext from '../context/exhibitorContext';
import styled from 'styled-components';
import { Context as AttendantContext } from '../context/AttendantContext';
import { Context as SocketContext } from '../context/SocketContext';
import SiteData from '../config';

const SliderPageRightPane = ({ className }) => {
  const {
    state,
    state: { user, user: { first_name, screen_name } = {} } = {},
    setUser,
  } = useContext(UserContext);

  const { state: { attendant = undefined } = {}, setAttendant } = useContext(
    AttendantContext
  );
  const {
    state: {
      tileChatMessages,
      tileChatParticipants,
      generalChatMessages,
      generalChatParticipants,
      loadingMoreMessages,
    },
    setTileChatMessages,
    setTileChatParticipants,
    setGeneralChatMessages,
    setGeneralChatParticipants,
    setLoadingMoreMessages,
  } = useContext(SocketContext);

  const [iFrameLink, setIFrameLink] = useState(null);

  useEffect(() => {
    // const displayName = screen_name || first_name;
    const displayName =
      screen_name && screen_name !== 'None' ? screen_name : first_name;
    console.log('SN OR FIRST NAME', screen_name, first_name);
    if (displayName) {
      console.log('link set')
      setIFrameLink(
        `https://deadsimplechat.com/-iDziHQLi?username=${displayName}`
      );
      console.log('display name', displayName)
      
    }
  }, [first_name, screen_name]);

  useEffect(() => {
    console.log('this is the user ' + JSON.stringify(user));
  }, [user]);

  // const findName = (name) => {
  //   if (user.screen_name) {
  //     name = user.screen_name
  //     return name
  //   } else {
  //     name = user.first_name;
  //     return name
  //   }
  // }

  return (
    <div className={className}>
      {/* {console.log(object)} */}
      {/* <Smallchatbox
        AttendantDashboard={false}
        messages={generalChatMessages}
        participants={generalChatParticipants}
        sendMessage={sendGeneralChatMessage}
        setLoadingMoreMessages={setLoadingMoreMessages}
        loadingMoreMessages={loadingMoreMessages}
        retrieveMoreMessages={retrieveMoreMessagesGeneral}
        deleteMessage={deleteMessage}
      /> */}
      {iFrameLink && <iframe src={iFrameLink} />}

      {/* ?username=${user.first_name} */}
    </div>
  );
};

export default styled(SliderPageRightPane)`
  height: 94%;
  color: black;
  overflow: hidden;

  iframe {
    overflow: hidden;
  }
`;
